/* 40 DAYS 40 NIGHTS — global.js */
(function () {
  'use strict';

  /* Mobile menu ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-site-nav]');
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    }
    // Close drawer when a nav link is clicked
    if (e.target.closest('[data-site-nav] a')) {
      var openNav = document.querySelector('[data-site-nav].is-open');
      if (openNav) {
        openNav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  /* Quantity steppers -------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: auto-submit on quantity change -------------------------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty]')) {
      var form = e.target.closest('form');
      if (form) form.submit();
    }
  });

  /* Product forms ------------------------------------------------------ */
  function initProductForm(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var buyBtn = root.querySelector('[data-add-to-cart]');
    var buyBtnText = buyBtn ? buyBtn.querySelector('span') : null;

    function money(cents) {
      var fmt = root.getAttribute('data-money-format') || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (buyBtn) { buyBtn.disabled = true; }
        if (buyBtnText) buyBtnText.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        var html = money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ' <s class="price__compare">' + money(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        if (buyBtnText) buyBtnText.textContent = variant.available ? buyBtn.getAttribute('data-label-add') : 'Sold out';
      }
      if (variant.featured_image) {
        var main = root.closest('[data-product-root]').querySelector('[data-gallery-main] img');
        if (main) { main.src = variant.featured_image.src; main.srcset = ''; }
      }
      // Keep URL in sync on product pages
      if (root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
    update();
  }

  /* Product gallery thumbnails ----------------------------------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var rootEl = thumb.closest('[data-product-root]');
    var main = rootEl.querySelector('[data-gallery-main] img');
    var img = thumb.querySelector('img');
    main.src = thumb.getAttribute('data-full') || img.src;
    main.srcset = '';
    main.alt = img.alt;
    rootEl.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
  });
})();
